import React, { useState } from 'react';
import { Dialog, Grid, Button, Typography } from '@mui/material';
import { Permission, UserGroup } from '@restore/services-lib';
import styled from 'styled-components';
import { useUsersContext } from 'context/users.context';
import { useAuthContext } from 'context/auth.context';
import { hasPermissions } from 'config/ability';
import { Div } from 'components/Elements/Div/Div';
import LoadingElement from 'components/LoadingElement/LoadingElement';

const RemoveWrapper = styled.span`
  color: red;
  cursor: pointer;
`;

const EntityName = styled.div`
  font-weight: 600;
`;

const RemovePermission = ({
  userGroup,
  permission,
}: {
  userGroup: UserGroup;
  permission: Permission;
}) => {
  const [showDelete, setShowDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const { editUserGroup } = useUsersContext();
  const { ability } = useAuthContext();

  // Return null if user does not have 'Update' permissions
  if (!hasPermissions(ability, 'update', 'UserGroup')) {
    return null;
  }

  const handleDeleteCampaign = async () => {
    setLoading(true);
    const permIndex = userGroup.permissions.indexOf(permission);
    const permissions = [...userGroup.permissions];
    permissions.splice(permIndex, 1);
    await editUserGroup({
      ...userGroup,
      permissionIds: permissions.map((permission) => permission.id),
    });
    setShowDelete(false);
    setLoading(false);
  };

  return (
    <>
      <RemoveWrapper onClick={() => setShowDelete(true)}>Remove</RemoveWrapper>
      <Dialog open={showDelete} onClose={() => setShowDelete(false)}>
        <Grid container textAlign='center' p={2} spacing={1.5}>
          <Grid item xs={12}>
            <Typography variant='h6'>
              You are about to remove permission:
              <EntityName>{permission.name}</EntityName>
              From the user group:
              <EntityName>{userGroup.name}</EntityName>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Div
              display='flex'
              width='100%'
              alignItems='flex-end'
              justifyContent='center'
              gap='0.75rem'
            >
              <Button onClick={() => setShowDelete(false)}>Cancel</Button>
              <LoadingElement
                loading={loading}
                element={<Button onClick={() => handleDeleteCampaign()}>Remove</Button>}
              />
            </Div>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default RemovePermission;
